import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
const rows = [{
  label: '📚 MegaPack Fiesta Épica (12 Tomos)',
  price: '$19.990'
}, {
  label: '🎁 Checklist Maestra de Supervivencia',
  price: 'GRATIS'
}, {
  label: '🎁 Pack 10 Plantillas de Invitaciones',
  price: 'GRATIS'
}, {
  label: '🎁 Guion del Animador Improvisado',
  price: 'GRATIS'
}, {
  label: '🎁 Mapa de Proveedores Estratégicos',
  price: 'GRATIS'
}, {
  label: '🎁 Fichas Recreo Épico — 30 Juegos',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago · Tarjeta'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="border-y border-white/5 bg-ink-2" data-id="element-177" data-mp="35pda81q8djp6">
      <div className="mx-auto max-w-2xl px-5 pt-[14px] text-center pb-[27px]" data-id="element-178" data-mp="1tgej5yumpmt7">
        <h2 className="mt-[-10px] mb-[-10px] pt-[9px] font-display text-3xl font-black text-white sm:text-4xl" data-id="element-179" data-mp="1ogs6bqipq8kx">
          🚀 Organizá el cumpleaños épico de tu hijo desde hoy
        </h2>
        <p className="mt-6 text-sm font-semibold text-white/60" data-id="element-180" data-mp="1yept09kxbxbf">
          Un pago único. Acceso de por vida. Sistema listo para aplicar en minutos.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-181" data-mp="2c41gjguwtd6d">
          <div className="flex items-center justify-between border-b border-white/10 px-5 pt-[7px] py-3 text-xs font-bold uppercase tracking-wide text-white/50" data-id="element-182" data-mp="283zj5jw7j5ww">
            <span data-id="element-183" data-mp="2h5z4goe98w5n">Qué incluye</span>
            <span data-id="element-184" data-mp="2h2usv5ygmy4y">Precio</span>
          </div>
          {rows.map(r => {
          const isPrice = r.price.startsWith('$');
          return <div key={r.label} className="flex items-center justify-between border-b border-white/5 px-5 pt-[2px] py-3.5 text-sm" data-id="element-185" data-mp="mqwkf67z66a4">
                <span className="pt-[3px] text-white/80" data-id="element-186" data-mp="2mtxmvvt7nqf4">{r.label}</span>
                <span className={isPrice ? 'font-bold text-white' : 'font-bold text-iris-soft'} data-id="element-187" data-mp="2rrz8ane401tr">
                  {r.price}
                </span>
              </div>;
        })}
          <div className="flex items-center justify-between bg-iris/15 px-5 py-4" data-id="element-188" data-mp="2vvyn91jqqsl0">
            <span className="text-sm font-bold text-white" data-id="element-189" data-mp="30u8itd9dnv75">
              Valor total real: <span className="text-white/40 line-through" data-id="element-190" data-mp="35r8ohn2bevxq">$101.940</span>
            </span>
            <span className="font-display text-2xl font-black text-white" data-id="element-191" data-mp="3aq36wnwdeihb">$19.990 ARS</span>
          </div>
        </div>

        <div className="mt-9" data-id="element-192" data-mp="3fid2okk62cri">
          <CTAButton href={CHECKOUT_URL} data-id="element-193" data-mp="3fk7g7dt3z2lk">Sí, quiero una fiesta épica para mi hijo</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50 pt-[5px]" data-id="element-194" data-mp="3oijfs5bydaq5">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-195" data-mp="3tf9pmax5za34">
              <Icon className="h-4 w-4 text-azure" data-id="element-196" data-mp="7hgj5tflqoje" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}